import type { Icon } from "@phosphor-icons/react";
import { cn } from "@volca/ui/lib/utils";
import {
  COLOR_TREATMENTS,
  type ComponentColor,
} from "@volca/ui/tokens/component-colors";

const SIZES = {
  sm: "size-6",
  md: "size-8",
} as const;

export interface IconTileProps {
  icon: Icon;
  color?: ComponentColor;
  size?: keyof typeof SIZES;
  className?: string;
}

export const IconTile = ({
  icon: Icon,
  color = "neutral",
  size = "sm",
  className,
}: IconTileProps) => (
  <span
    aria-hidden="true"
    className={cn(
      "inline-flex shrink-0 items-center justify-center rounded-md",
      color === "neutral"
        ? "border border-line bg-surface-raised text-subtle"
        : COLOR_TREATMENTS[color].bold,
      SIZES[size],
      className,
    )}
  >
    <Icon size={size === "md" ? 18 : 14} />
  </span>
);
